import { render, staticRenderFns } from "./TextFX.vue?vue&type=template&id=a496b808&scoped=true&"
import script from "./TextFX.vue?vue&type=script&lang=js&"
export * from "./TextFX.vue?vue&type=script&lang=js&"
import style0 from "./TextFX.vue?vue&type=style&index=0&id=a496b808&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a496b808",
  null
  
)

export default component.exports